<template>
  <div class="personal">
    <div class="box"  v-bind:style="{ minHeight: Height + 'px' }">
      <div class="box_left">
        <h2>个人信息</h2>
        <el-divider></el-divider>
        <p style="margin-top: 20px">
          <span>用&ensp;户&ensp;名：</span><span>{{ information.name }}</span>
        </p>
        <p>
          <span>所属机构：</span
          ><span v-if="information.mechanism">{{
            information.mechanism.name
          }}</span>
        </p>
        <p>
          <span>电子邮箱：</span><span>{{ information.email }}</span>
        </p>
        <p><span></span><span></span></p>
      </div>
      <div class="box_right">
        <h2>个人收藏/关注</h2>
        <!-- <el-divider></el-divider> -->
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          style="margin-top: 10px"
        >
          
          <!-- <el-tab-pane label="律所" name="second"></el-tab-pane> -->
          <el-tab-pane label="案例" name="third"></el-tab-pane>
          <el-tab-pane label="法律法规" name="first"></el-tab-pane>
          <el-tab-pane label="企业" name="forth"></el-tab-pane>
        </el-tabs>
        <div v-if="totalCount > 0">
          <ul>
            <li v-for="(item, index) in list" :key="index">
              <div class="box_main_list">
                <div class="title">
                    <!-- 法律法规 -->
                  <router-link v-if="item.doctype == '3'"
                    :to="{
                      path: `/lawsDetail/${item.docid}`,
                    }"
                    target="_blank"
                  >
                    <span style="position: absolute; top: 2px">
                         {{ ((current_page - 1)*15) + index + 1 + "、"}}
                    </span>

                    <h2
                      style="
                        display: inline-block;
                        font-weight: 500;
                        font-size: 16px;
                        cursor: pointer;
                        width: 800px;
                        word-break: normal;
                        margin-left: 23px;
                        line-height: 32px;
                      "
                      v-if="item.docname !== null"
                    >
                      <span v-if="item.docname.length > 35"
                        >{{ item.docname.slice(0, 35) }}...</span
                      >
                      <span v-if="item.docname.length <= 35">{{
                        item.docname
                      }}</span
                      ><span class="timeCss">{{
                        item.create_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}</span>
                    </h2>
                  </router-link>
                  <!-- 文书 -->
                  <router-link
                    v-if="item.doctype == '1'"
                    :to="{
                      path: `/detail/${item.docid}`,
                      query: { keyword: '', type: '1' },
                    }"
                    target="_blank"
                  >
                    <span style="position: absolute; top: 2px">{{((current_page - 1)*15)+
                      index + 1 + "、"
                    }}</span>

                    <h2
                      style="
                        display: inline-block;
                        font-weight: 500;
                        font-size: 16px;
                        cursor: pointer;
                        width: 800px;
                        word-break: normal;
                        margin-left: 23px;
                        line-height: 32px;
                      "
                      v-if="item.docname !== null"
                    >
                      <span v-if="item.docname.length > 35"
                        >{{ item.docname.slice(0, 35) }}...</span
                      >
                      <span v-if="item.docname.length <= 35">{{
                        item.docname
                      }}</span
                      ><span class="timeCss">{{
                        item.create_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}</span>
                    </h2>
                  </router-link>
                  <!-- 律所 -->
                  <div>
                      <span v-if="item.doctype == '2' && item.docname !== null" style="">{{ ((current_page - 1)*15)+
                        index + 1 + "、"
                      }}</span>
                  <h2
                    @click="lawDetail(item.docid)"
                    style="
                      display: inline-block;
                      font-weight: 900;
                      font-size: 18px;
                    "
                    v-if="item.doctype == '2' && item.docname !== null"
                  >
                    <span v-if="item.docname.length > 35"
                      >{{ item.docname.slice(0, 35) }}...</span
                    >
                    <span v-if="item.docname.length <= 35">{{
                      item.docname
                    }}</span
                    ><span class="timeCss">{{
                      item.create_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</span>
                  </h2>
                  </div>
                  <!-- 企业： 跳转页面需要修改 --> 
                  <router-link v-if="item.doctype == '4'"
                    :to="{
                      path: `/CompaniesDetails/${item.docid}`,
                    }"
                    target="_blank"
                  >
                    <span style="position: absolute; top: 2px">
                         {{ ((current_page - 1)*15) + index + 1 + "、"}}
                    </span>

                    <h2
                      style="
                         display: inline-block;
                        font-weight: 500;
                        font-size: 16px;
                        cursor: pointer;
                        width: 800px;
                        word-break: normal;
                        margin-left: 23px;
                        line-height: 32px;
                      "
                      v-if="item.docname !== null"
                    >
                      <span v-if="item.docname.length > 35"
                        >{{ item.docname.slice(0, 35) }}...</span
                      >
                      <span v-if="item.docname.length <= 35">{{
                        item.docname
                      }}</span
                      ><span class="timeCss">{{
                        item.create_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}</span>
                    </h2>
                  </router-link>
                  <div class="collection">
                    <el-popconfirm
                      :title="item.doctype == '4'?'确认取消关注吗？':'确认取消收藏吗？'"
                      @confirm="Cancel(item)"
                    >
                      <img
                        slot="reference"
                        style="cursor: pointer"
                        src="../../assets/imgs/2.0/收藏3.png"
                        alt=""
                      />
                    </el-popconfirm>
                    <!-- <el-tooltip
                        content="取消收藏"
                        placement="bottom"
                        effect="light"
                      >
                        
                      </el-tooltip> -->
                  </div>
                </div>
              </div>
              <el-divider></el-divider>
            </li>
          </ul>
          <div class="page-bar" v-if="totalCount > 15">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount > 10000 ? 10000 : totalCount"
              @current-change="handleCurrentChange"
              :current-page.sync="current_page"
              :page-size="15"
            >
            </el-pagination>
          </div>
        </div>
        <div v-if="totalCount <= 0" class="imgs">
          <img style="" src="../../assets/imgs/2.0/zanwushuj.png" alt="" />
        </div>
      </div>
    </div>
    <ComFooter></ComFooter>
  </div>
</template>

<script>
import store from "@/store";
import ComFooter from "../../components/ComFooter.vue";
export default {
  data() {
    return {
      activeName: "third",
      doctype: "1",
      information: {},
      list: [],
      page: 1,
      totalCount: 0,
      current_page: 1,
      Height: 0,
    };
  },
  components: {
    ComFooter,
  },
mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是190
    // console.log(this.name)
    this.Height = document.documentElement.clientHeight - 140; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 140;
    };
  },
  computed: {},
  created() {
    this.getPerson();
    this.personalList();
  },
  methods: {
    getPerson() {
      this.$http
        .get("/me", {})
        .then((res) => {
          // console.log(res);
          this.information = res.data.data;
        })
        .catch((error) => {});
    },
    personalList() {
      let doc = {
        user_id: store.getCookie("user_id"),
        role: store.getCookie("role"),
        doctype: this.doctype,
      };
      this.$http
        .get("/colllist?doctype=" + this.doctype + "&page=" + this.page)
        .then((res) => {
          console.log('res', res);
          this.list = res.data.data.data;
          this.totalCount = res.data.data.total;
          console.log('list', this.list);
        })
        .catch((error) => {});
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      if (tab.label == "法律法规") {
        this.doctype = "3";
      } else if (tab.label == "律所") {
        this.doctype = "2";
      } else if(tab.label == '案例'){
        this.doctype = "1";
      }else if(tab.label == '企业'){
        this.doctype = "4"
      }
      this.page = 1;
      this.current_page = 1;
      this.personalList();
    },
    Cancel(item) {
      let id = {
        docid: item.docid,
      };
      this.$http
        .post("/delcoll", id)
        .then((res) => {
          // console.log(res);
          if(item.doctype == '4'){
this.$message({
            message: '取消关注成功',
            type: "success",
          });
          }else{
this.$message({
            message: res.data.message,
            type: "success",
          });
          }
          
          this.list = res.data.data.data;
          this.personalList();
        })
        .catch((error) => {});
    },
    handleCurrentChange(val) {
      this.page = val;
      this.current_page = val;
      //   this.loading_box = true;
      this.personalList();
      //   window.scrollTo(0, 0);
    },
    // 律所详情页
    lawDetail(id) {
      let newUrl = this.$router.resolve({
        path: "/lawsDetail",
        query: { id: id, page: 1, pagesize: 5 },
      });
      // console.log(newUrl)
      window.open(newUrl.href, "_blank");
    },
  },
};
</script>

<style  lang='less' scoped>
.personal {
  width: 100%;
  //   min-width: 1280px;
  max-width: 1920px;
  //   min-width: 1280px;
  //   margin: auto;
  .box {
    width: 1280px;
    // height: 200px;
    min-height: calc(100vh - 200px);
    min-width: 1280px;
    max-width: 1280px;
    margin: auto;
    // background: white;
    padding: 20px 50px;
    display: flex;
    .box_left {
      width: 20%;
      min-width: 300px;
      background: white;
      padding: 20px;
      border-radius: 10px;
      margin-right: 30px;
      font-family: "SimHei";
      h2 {
        //   line-height: 50px;
        font-size: 18px;
        //   font-family: "SimHei";
      }
      p {
        //   display: inline-block;
        margin-bottom: 20px;
      }
    }
    .box_right {
      width: 80%;
      background: white;
      border-radius: 10px;
      padding: 20px;

      h2 {
        //   line-height: 50px;
        font-size: 18px;
        font-family: "SimHei";
        // margin-bottom: 20px;
      }
    }
  }
}
.box_main_list {
  // margin: 10px 0 20px 0px;
  // height: 200px;
  // height: 300px;
  border-radius: 5px;

  .title {
    position: relative;

    display: flex;
    justify-content: space-between;
    // margin-bottom: 10px;
    line-height: 28px;
    h2 {
      font-size: 16px;
      font-weight: 600;
      // margin-left: 200px;
    }
    .el-tag {
      margin: 0 0px 0 25px;
      position: absolute;
      top: 0px;
    }
  }
  .title :hover {
    // color: rgb(197, 197, 197);
     color: #cf8700;
  }
  .case {
    background: #cf8700;
    color: white;
    // display: inline-block;
    margin: 5px;
    // padding: 5px;
    border-radius: 5px;
  }
  .box_detail {
    margin-top: 10px;
    // height: 200px;
    background: #ffffff;
    padding: 18px;
    .basic {
      margin-bottom: 30px;
      font-size: 16px;
      display: flex;
      .basic_left {
        width: 15%;
        height: 56px;
        display: inline-block;
        padding: 20px 20px 10px 20px;
        border-right: 1px solid rgb(172, 112, 0);
      }
      .basic_right {
        width: 85%;
        padding-left: 10px;
        .basic_content {
          min-width: 500px;
          div {
            // display: block;
            line-height: 30px;
          }
        }
        // justify-content: space-around;
        // width: 500px;
        // p {
        //   // display: inline-block;
        //   height: 20px;
        //   line-height: 20px;
        //   min-width: 45%;
        //   // max-width: 50%;
        //   // margin: 5px;
        // }
      }
      .details {
        width: 85%;
        padding-left: 10px;
        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;

        p {
          line-height: 20px;
        }
      }
    }
    .card {
      margin: 20px 0;
      .mores {
        display: flex;
        justify-content: center;
        span {
          display: inline-block;
          cursor: pointer;
        }
      }
      p {
        line-height: 20px;
        overflow: hidden;
        -webkit-line-clamp: 5;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .hits {
        line-height: 30px;
        display: flex;
        span {
          display: inline-block;
        }
      }
    }
    .detail {
    }
  }
}
.collection {
  img {
    width: 28px;
  }
}
.el-divider--horizontal {
  margin: 8px 0;
  background: 0 0;
  border-top: 1px dashed #e8eaec;
}
.timeCss {
  display: inline-block;
  margin: 0 20px;
  line-height: 28px;
  font-size: 12px;

  color: #9c9c9c;
}
// / 分页按钮
.page-bar {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}
.imgs {
  // margin: auto;
  display: flex;
  justify-content: center;
  align-content: center;
  img {
    width: 500px;
  }
}
</style>